import { useCallback } from "react";

import { useTstTableLocalState } from "../../domain/table/useTstTableLocalState";

/**
 * Persists the FilterBar collapsed/expanded state per table in localStorage so
 * it survives refresh and back-navigation.
 * @param storageKey - Unique key for the table (typically the table id).
 * @param defaultCollapsed - Collapsed state used until the user changes it.
 */
export function useFilterBarCollapse(
    storageKey: string,
    defaultCollapsed = false
): [boolean, (collapsed: boolean) => void] {
    const [local, setLocal] = useTstTableLocalState(storageKey);

    const collapsed = local.filtersCollapsed ?? defaultCollapsed;

    const setCollapsed = useCallback(
        (next: boolean) =>
            setLocal((prev) => ({ ...prev, filtersCollapsed: next })),
        [setLocal]
    );

    return [collapsed, setCollapsed];
}
